module.exports = __webpack_public_path__ + "static/img/frontpage3.8a94467.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/frontpage3.png
// module id = ucbD
// module chunks = 0